// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ProjectVO } from '@project/model/vo/project.vo';
import { ProjectUtils } from '@project/components/project/util/project-utils';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { ArrayUtils } from '@shared/util/array-utils';
import { StringUtils } from '@shared/util/string-utils';
import { ProjectOptionUtils } from '@project/components/project/util/project-option.utils';
import { ProjectOptionDefIds } from '@project/components/project/constants/project-option-def-ids';
import { ProjectModel } from '@project/model/project.model';
import { ProjectModelService } from '@project/service/project-model.service';
import { ApplicationService } from '@shared/application/application.service';
import { UserModel } from '@user/model/user.model';
import { ProjectService } from '@project/components/import-export/service/project.service';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ProjectUserModel } from '@project/model/project-user.model';
import { ConfigurationMetaData } from '../models/wizard-model.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationCreationService {

  constructor(
    private projectModel: ProjectModel,
    private userModel: UserModel,
    private projectModelService: ProjectModelService,
    private projectService: ProjectService,
    private applicationService: ApplicationService,
    private localeResourceManager: LocaleResourceManager,
    private projectUserModel: ProjectUserModel,
  ) {}

  public async prepareNewConfiguration(model: ConfigurationMetaData): Promise<void> {
    this.removeNotSavedProjects();
    await this.projectModelService.clearCurrentProject();
    this.projectModelService.createNewConfigurationGroup();
    const project: ProjectVO = ProjectUtils.createNewProjectVO(this.applicationService.applicationVersion);
    // User created new configuration group, now he wants to add another configuration that must replace current not saved configuration
    const configurationGroup: ProjectGroupVO = this.projectModel.currentProject.projectGroup;
    configurationGroup.projects.push(project);
    this.updateProjectConfiguration(project, model);
    await this.projectModelService.setCurrentProject(project);
  }

  private removeNotSavedProjects(): void {
    if (this.projectModel.isCurrentProjectConfigurationGroup) {
      const configurationGroup: ProjectGroupVO = this.projectModel.configurationGroup;
      ArrayUtils.removeFromArray(configurationGroup.projects, ProjectUtils.isNewProject);
    }
  }

  private updateProjectConfiguration(project: ProjectVO, model: ConfigurationMetaData): void {
    if (!project) {
      return;
    }

    project.name = model.configurationName;
    if (StringUtils.isEmpty(project.name)) {
      project.name = this.projectService.getDefaultProjectName();
    }
    let createdByValue: string = model.userName;
    createdByValue = ProjectOptionUtils.getCleanedProjectOptionValue(createdByValue);
    if (StringUtils.isEmpty(createdByValue)) {
      createdByValue = this.userModel.userProfile.isRegisteredUserAccount()
        ? this.userModel.userProfile.user.getDisplayName()
        : this.localeResourceManager.getValueByKey('confNameComponent.label.guest');
    }
    ProjectOptionUtils.setDefaultProjectOptionValues(project, this.projectUserModel.projectOptionDefs);
    ProjectUtils.setOrUpdateProjectOption(ProjectOptionDefIds.CREATED_BY, createdByValue, project, this.projectUserModel.projectOptionDefs);
    let customMaterialNumberValue: string = model.userMaterialNumber;
    customMaterialNumberValue = ProjectOptionUtils.getCleanedProjectOptionValue(customMaterialNumberValue);
    if (StringUtils.isEmpty(customMaterialNumberValue)) {
      const maxLength = this.projectUserModel.getProjectOptionDef(ProjectOptionDefIds.CUSTOM_MATERIAL_NUMBER).maxLength;
      customMaterialNumberValue = ProjectOptionUtils.trimValueByMaxLength(project.name, maxLength);
    }
    ProjectUtils.setOrUpdateProjectOption(
      ProjectOptionDefIds.CUSTOM_MATERIAL_NUMBER,
      customMaterialNumberValue,
      project,
      this.projectUserModel.projectOptionDefs
    );
  }
}
